import { makeActionCreator } from '../../config/store/utils'
import theme from '../../config/styles/theme'
import { MONTHS_DICTIONARY } from '../../config/settings/constants'
import { getAgilePurchaseTradedSectors } from '../../services/agilePurchase'

export const GET_AGILE_PURCHASE_BY_SECTOR = 'GET_AGILE_PURCHASE_BY_SECTOR'
export const GET_AGILE_PURCHASE_BY_SECTOR_ERROR = 'GET_AGILE_PURCHASE_BY_SECTOR_ERROR'
export const GET_AGILE_PURCHASE_BY_SECTOR_SUCCESS = 'GET_AGILE_PURCHASE_BY_SECTOR_SUCCESS'

export const onGetAgilePurchaseBySector = makeActionCreator(GET_AGILE_PURCHASE_BY_SECTOR)
export const onGetAgilePurchaseBySectorError = makeActionCreator(GET_AGILE_PURCHASE_BY_SECTOR_ERROR, 'payload')
export const onGetAgilePurchaseBySectorSuccess = makeActionCreator(GET_AGILE_PURCHASE_BY_SECTOR_SUCCESS, 'payload')

const THEME_COLORS = [
  { name: 'Fuerzas Armadas', value: 1, color: theme.palette.charts.cobalt },
  { name: 'Gobierno Central, Universidades', value: 2, color: theme.palette.charts.purpleHeart },
  { name: 'Legislativo y Judicial', value: 3, color: theme.palette.charts.lightenNavyBlue },
  { name: 'Municipalidades', value: 4, color: theme.palette.charts.apple },
  { name: 'Obras Públicas', value: 5, color: theme.palette.charts.saffron },
  { name: 'Otros', value: 6, color: theme.palette.charts.tonysPink },
  { name: 'Salud', value: 7, color: theme.palette.charts.darkRed },
  { name: 'Sin Clasificar', value: 8, color: theme.palette.charts.deepSaffron },
  { name: 'Total Compra Ágil', value: 0, color: theme.palette.charts.tangerine }
]

export const onGetAgilePurchaseBySectorThunk =
  ({ year, sectorsIds }) =>
  async dispatch => {
    dispatch(onGetAgilePurchaseBySector())

    try {
      const response = await getAgilePurchaseTradedSectors({ sectorsIds, year })
      if (response.status !== 200) {
        return dispatch(onGetAgilePurchaseBySectorError(response.data.errores))
      }
      const data = response.data?.payload
        .filter(item => item.idSector !== THEME_COLORS[7].value)
        .sort((a, b) => a.mes - b.mes)

      const enhancedData = sectorsIds.reduce((collection, sectorId) => {
        const dataByMonth = data.filter(item => item.idSector === sectorId)

        if (dataByMonth.length === 0) {
          return collection
        }

        const groupedData = dataByMonth.reduce((acc, item) => {
          if (!acc[item.idSector]) {
            acc[item.idSector] = []
          }

          acc[item.idSector].push({
            mes: item.mes,
            cantidad: item.cantidad,
            monto: item.monto,
            montoUSD: item.montoUSD,
            anio: item.anio,
            sector: THEME_COLORS.find(sectorOpt => sectorOpt.value === item.idSector)?.name,
            idSector: item.idSector
          })

          return acc
        }, {})

        let accumulatedCantidad = 0
        let amountAccumulatedCLP = 0
        let amountAccumulatedUSD = 0

        const accumulatedData = Object.keys(groupedData).reduce((acc, sectorId) => {
          const sectorName = THEME_COLORS.find(sector => sector.value === parseInt(sectorId))?.name

          groupedData[sectorId]
            .sort((a, b) => a.mes - b.mes)
            .forEach(entry => {
              accumulatedCantidad += entry.cantidad
              amountAccumulatedCLP += entry.monto
              amountAccumulatedUSD += entry.montoUSD

              acc.push({
                mes: entry.mes,
                cantidad: accumulatedCantidad,
                sector: sectorName,
                monto: amountAccumulatedCLP,
                montoUSD: amountAccumulatedUSD,
                anio: entry.anio,
                idSector: entry.idSector
              })
            })

          return acc
        }, [])

        return collection.concat({
          amountMonthlyCLP: dataByMonth.map(item => item.monto),
          amountMonthlyUSD: dataByMonth.map(item => item.montoUSD),
          amountAccumulatedCLP: accumulatedData.map(item => item.monto),
          amountAccumulatedUSD: accumulatedData.map(item => item.montoUSD),
          orders: dataByMonth.map(item => item.cantidad),
          ordersAccumulated: accumulatedData.map(item => item.cantidad),
          color: THEME_COLORS.find(color => color.value === sectorId).color,
          month: dataByMonth.map(item => MONTHS_DICTIONARY.find(m => m.value === item.mes).name),
          name: THEME_COLORS.find(sector => sector.value === sectorId).name
        })
      }, [])

      const csv = [
        ['Meses', 'Sector del estado', 'N° de órdenes de compra', 'Monto transado (CLP)', 'Monto transado (USD)'],
        ...enhancedData.reduce((collection, item) => {
          const rows = item.month
            .map((month, index) => [
              month,
              item.name,
              item.orders[index],
              item.amountMonthlyCLP[index],
              item.amountMonthlyUSD[index]
            ])
            .sort((a, b) => a.mes - b.mes)

          return [...collection, ...rows]
        }, [])
      ]
      const csvAccumulated = [
        ['Meses', 'Sector del estado', 'N° de órdenes de compra', 'Monto transado (CLP)', 'Monto transado (USD)'],
        ...enhancedData.reduce((collection, item) => {
          const rows = item.month
            .map((month, index) => [
              month,
              item.name,
              item.ordersAccumulated[index],
              item.amountAccumulatedCLP[index],
              item.amountAccumulatedUSD[index]
            ])
            .sort((a, b) => a.mes - b.mes)

          return [...collection, ...rows]
        }, [])
      ]
      const dataCompleted = [
        ...enhancedData.reduce((collection, item) => {
          const rows = item.month.map((month, index) => ({
            month: month,
            name: item.name,
            orders: item.orders[index],
            amountMonthlyCLP: item.amountMonthlyCLP[index],
            amountMonthlyUSD: item.amountMonthlyUSD[index],
            ordersAccumulated: item.ordersAccumulated[index],
            amountAccumulatedCLP: item.amountAccumulatedCLP[index],
            amountAccumulatedUSD: item.amountAccumulatedUSD[index]
          }))

          return [...collection, ...rows]
        }, [])
      ]

      dispatch(onGetAgilePurchaseBySectorSuccess({ csv, csvAccumulated, data: dataCompleted, enhancedData }))
    } catch (error) {
      dispatch(
        onGetAgilePurchaseBySectorError({
          error: 'Error al obtener datos',
          data: [],
          csv: [],
          csvAccumulated: [],
          enhancedData: []
        })
      )
    }
  }
